<template>
  <weui-group :title="`${formatDate(draft.date)} 可供预约课程的时段：`">
    <weui-cell v-for="t in formatted_available_times" :key="t" @click="selectTime(t)" style="text-align: center">{{ t }}</weui-cell>
  </weui-group>
</template>

<script>
import weui from 'weui.js';

import { WeuiGroup, WeuiCell } from '@/components/weui';
import mixinFormatters from '@/mixins/formatters';
import { ROUTE_COURSE_CREATE, ROUTE_COURSE_CREATE_CREATED } from '@/router/names';
import datetimeUtils from '@/utils/datetime';
import mixinDraft from './draft.mixin';

export default {
    computed: {
        formatted_available_times() {
            const vm = this;
            return Array.isArray(this.available_times)
                ? this.available_times.map(t => vm.formatTime(t))
                : [];
        },
    },
    created() {
        if (!this.draft.date) {
            this.$router.replace({
                name: ROUTE_COURSE_CREATE,
            });
        }
        this.fetchAvailableTimes({
            date: this.draft.date,
        });
    },
    methods: {
        selectTime(time) {
            const message = `确认申请${this.formatDate(this.draft.date)}${this.formatTime(time)}的课程吗？`;
            weui.confirm(message, () => {
                this.fillDraft({
                    start_time: time,
                    end_time: datetimeUtils.getNextHour(time),
                });

                this.createDraft(this.draft)
                    .then(() => {
                        this.$router.replace({
                            name: ROUTE_COURSE_CREATE_CREATED,
                            params: {
                                id: this.created.id,
                            },
                        });
                    });
            });
        },
    },
    mixins: [
        mixinDraft,
        mixinFormatters,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/course/TimeSelector.vue